// Persistent footer band. Appears on every page.
// - Indie Law CTA (done-for-you upsell)
// - Legal links: Privacy + Terms + copyright

import { Link } from "react-router-dom";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <>
      <footer className="footer-band" data-testid="indie-law-footer">
        Need done-for-you trademark help instead?{" "}
        <a
          href="https://www.indielaw.com/call"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="indie-law-call-link"
        >
          Book a free Brand Protection Call with Indie Law →
        </a>
      </footer>

      <div
        className="footer-legal"
        data-testid="footer-legal"
        style={{
          background: "var(--navy)",
          color: "rgba(242, 233, 219, 0.7)",
          padding: "1rem 1.25rem",
          fontSize: "0.78rem",
          letterSpacing: "0.02em",
          textAlign: "center",
          borderTop: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <span style={{ display: "inline-flex", gap: "1.25rem", flexWrap: "wrap", justifyContent: "center", alignItems: "center" }}>
          <span>© {year} Get Trademarked, LLC</span>
          <span aria-hidden="true" style={{ opacity: 0.5 }}>·</span>
          <Link to="/privacy" data-testid="footer-privacy-link" style={{ color: "var(--yellow)", textDecoration: "none", fontWeight: 700 }}>
            Privacy Policy
          </Link>
          <span aria-hidden="true" style={{ opacity: 0.5 }}>·</span>
          <Link to="/terms" data-testid="footer-terms-link" style={{ color: "var(--yellow)", textDecoration: "none", fontWeight: 700 }}>
            Terms of Use
          </Link>
        </span>
      </div>
    </>
  );
};
